import { render } from "./index.vue?vue&type=template&id=07850c2b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=07850c2b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07850c2b"],['__file',"src/views/Home/Branch/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07850c2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07850c2b', __exports__)) {
    console.log('reload')
    api.reload('07850c2b', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=07850c2b&scoped=true", () => {
    console.log('re-render')
    api.rerender('07850c2b', render)
  })

}


export default __exports__